module.exports = __webpack_public_path__ + "img/new-icon-perlu-tindak-lanjut.4f0a3b17.svg";